import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { LogoMark } from "@/components/brand/LogoMark";
import { useAuth } from "@/context/AuthContext";
import { login, formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { setUser } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = await login(email, password);
      setUser(user);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main data-testid="admin-login-page" className="min-h-screen flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-12 text-foreground">
          <LogoMark className="w-10 h-10" />
          <span className="leading-tight">
            <span className="block text-sm tracking-[0.25em] font-medium">CLEAR HORIZON</span>
            <span className="block text-[10px] tracking-[0.35em] text-muted-foreground">CONSULTING</span>
          </span>
        </div>
        <h1 className="font-serif text-4xl font-light tracking-tight">Admin sign in</h1>
        <p className="mt-3 text-sm font-light text-muted-foreground">Private access to leads and bookings.</p>
        <form data-testid="admin-login-form" onSubmit={handleSubmit} className="mt-10 space-y-8">
          <input
            data-testid="admin-email-input"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email address"
            className="input-line"
          />
          <input
            data-testid="admin-password-input"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className="input-line"
          />
          {error && (
            <p data-testid="admin-login-error" className="text-sm text-red-400">{error}</p>
          )}
          <button
            type="submit"
            data-testid="admin-login-submit"
            disabled={loading}
            className="inline-flex items-center gap-2 bg-primary text-primary-foreground text-sm font-medium px-10 py-4 hover:scale-105 transition-transform duration-300 disabled:opacity-50 disabled:hover:scale-100"
          >
            {loading ? "Signing in..." : "Sign In"} <ArrowUpRight className="w-4 h-4" />
          </button>
        </form>
      </div>
    </main>
  );
}
